var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBall = function SvgBall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.781 4.987a16.25 16.25 0 0 1 21.458 9.37 1.3 1.3 0 0 1 .166.472 16.25 16.25 0 1 1-30.81 0 1.3 1.3 0 0 1 .166-.472q.108-.29.226-.576a16.25 16.25 0 0 1 8.794-8.794m-7.12 11.675a13.75 13.75 0 0 0 3.936 13.37l3.046-3.51-2.587-8.156zm5.223-.657L7.487 14.3A13.75 13.75 0 0 1 18.75 6.307v4.722zm9.366-4.976 6.866 4.976 4.397-1.705A13.75 13.75 0 0 0 21.25 6.307zm12.089 5.633-4.395 1.704-2.546 8.026 3.021 3.625q.154-.144.304-.294a13.75 13.75 0 0 0 3.616-13.061m-5.89 14.896-3.034-3.641h-8.673l-3.17 3.654a13.75 13.75 0 0 0 14.877-.013M13.53 17.899l2.384 7.518h8.17l2.384-7.518L20 13.211z",
    clipRule: "evenodd"
  })));
};
export default SvgBall;